import { render } from "./quarter-reports.vue?vue&type=template&id=60db45fb&scoped=true"
import script from "./quarter-reports.vue?vue&type=script&lang=js"
export * from "./quarter-reports.vue?vue&type=script&lang=js"

import "./quarter-reports.vue?vue&type=style&index=0&id=60db45fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60db45fb"]])

export default __exports__